/* eslint-disable max-len */

export type CountryItem = {
  co: string;
  ph: string;
  na: string;
};

export const COUNTRIES: CountryItem[] = [{
  "co": "au",
  "ph": "61",
  "na": "\u0410\u0432\u0441\u0442\u0440\u0430\u043b\u0438\u044f"
}, {
  "co": "at",
  "ph": "43",
  "na": "\u0410\u0432\u0441\u0442\u0440\u0438\u044f"
}, {
  "co": "az",
  "ph": "994",
  "na": "\u0410\u0437\u0435\u0440\u0431\u0430\u0439\u0434\u0436\u0430\u043d"
}, {
  "co": "ax",
  "ph": "35818",
  "na": "\u0410\u043b\u0430\u043d\u0434\u0441\u043a\u0438\u0435 \u043e-\u0432\u0430"
}, {
  "co": "al",
  "ph": "355",
  "na": "\u0410\u043b\u0431\u0430\u043d\u0438\u044f"
}, {
  "co": "dz",
  "ph": "213",
  "na": "\u0410\u043b\u0436\u0438\u0440"
}, {
  "co": "ai",
  "ph": "1264",
  "na": "\u0410\u043d\u0433\u0438\u043b\u044c\u044f"
}, {
  "co": "ao",
  "ph": "244",
  "na": "\u0410\u043d\u0433\u043e\u043b\u0430"
}, {
  "co": "ad",
  "ph": "376",
  "na": "\u0410\u043d\u0434\u043e\u0440\u0440\u0430"
}, {
  "co": "ag",
  "ph": "1268",
  "na": "\u0410\u043d\u0442\u0438\u0433\u0443\u0430 \u0438 \u0411\u0430\u0440\u0431\u0443\u0434\u0430"
}, {
  "co": "mo",
  "ph": "853",
  "na": "\u0410\u043e\u043c\u044b\u043d\u044c"
}, {
  "co": "ar",
  "ph": "54",
  "na": "\u0410\u0440\u0433\u0435\u043d\u0442\u0438\u043d\u0430"
}, {
  "co": "am",
  "ph": "374",
  "na": "\u0410\u0440\u043c\u0435\u043d\u0438\u044f"
}, {
  "co": "aw",
  "ph": "297",
  "na": "\u0410\u0440\u0443\u0431\u0430"
}, {
  "co": "af",
  "ph": "93",
  "na": "\u0410\u0444\u0433\u0430\u043d\u0438\u0441\u0442\u0430\u043d"
}, {
  "co": "bs",
  "ph": "1242",
  "na": "\u0411\u0430\u0433\u0430\u043c\u0441\u043a\u0438\u0435 \u043e\u0441\u0442\u0440\u043e\u0432\u0430"
}, {
  "co": "bd",
  "ph": "880",
  "na": "\u0411\u0430\u043d\u0433\u043b\u0430\u0434\u0435\u0448"
}, {
  "co": "bb",
  "ph": "1246",
  "na": "\u0411\u0430\u0440\u0431\u0430\u0434\u043e\u0441"
}, {
  "co": "bh",
  "ph": "973",
  "na": "\u0411\u0430\u0445\u0440\u0435\u0439\u043d"
}, {
  "co": "by",
  "ph": "375",
  "na": "\u0411\u0435\u043b\u0430\u0440\u0443\u0441\u044c"
}, {
  "co": "bz",
  "ph": "501",
  "na": "\u0411\u0435\u043b\u0438\u0437"
}, {
  "co": "be",
  "ph": "32",
  "na": "\u0411\u0435\u043b\u044c\u0433\u0438\u044f"
}, {
  "co": "bj",
  "ph": "229",
  "na": "\u0411\u0435\u043d\u0438\u043d"
}, {
  "co": "bm",
  "ph": "1441",
  "na": "\u0411\u0435\u0440\u043c\u0443\u0434\u0441\u043a\u0438\u0435 \u043e-\u0432\u0430"
}, {
  "co": "bg",
  "ph": "359",
  "na": "\u0411\u043e\u043b\u0433\u0430\u0440\u0438\u044f"
}, {
  "co": "bo",
  "ph": "591",
  "na": "\u0411\u043e\u043b\u0438\u0432\u0438\u044f"
}, {
  "co": "bq",
  "ph": "599",
  "na": "\u0411\u043e\u043d\u0430\u0439\u0440\u0435, \u0421\u0438\u043d\u0442-\u042d\u0441\u0442\u0430\u0442\u0438\u0443\u0441 \u0438 \u0421\u0430\u0431\u0430"
}, {
  "co": "ba",
  "ph": "387",
  "na": "\u0411\u043e\u0441\u043d\u0438\u044f"
}, {
  "co": "bw",
  "ph": "267",
  "na": "\u0411\u043e\u0442\u0441\u0432\u0430\u043d\u0430"
}, {
  "co": "br",
  "ph": "55",
  "na": "\u0411\u0440\u0430\u0437\u0438\u043b\u0438\u044f"
}, {
  "co": "io",
  "ph": "246",
  "na": "\u0411\u0440\u0438\u0442\u0430\u043d\u0441\u043a\u0430\u044f \u0442\u0435\u0440\u0440\u0438\u0442\u043e\u0440\u0438\u044f \u0432 \u0418\u043d\u0434\u0438\u0439\u0441\u043a\u043e\u043c \u043e\u043a\u0435\u0430\u043d\u0435"
}, {
  "co": "vg",
  "ph": "1284",
  "na": "\u0411\u0440\u0438\u0442\u0430\u043d\u0441\u043a\u0438\u0435 \u0412\u0438\u0440\u0433\u0438\u043d\u0441\u043a\u0438\u0435 \u043e-\u0432\u0430"
}, {
  "co": "bn",
  "ph": "673",
  "na": "\u0411\u0440\u0443\u043d\u0435\u0439"
}, {
  "co": "bf",
  "ph": "226",
  "na": "\u0411\u0443\u0440\u043a\u0438\u043d\u0430 \u0424\u0430\u0441\u043e"
}, {
  "co": "bi",
  "ph": "257",
  "na": "\u0411\u0443\u0440\u0443\u043d\u0434\u0438"
}, {
  "co": "bt",
  "ph": "975",
  "na": "\u0411\u0443\u0442\u0430\u043d"
}, {
  "co": "vu",
  "ph": "678",
  "na": "\u0412\u0430\u043d\u0443\u0430\u0442\u0443"
}, {
  "co": "va",
  "ph": "379",
  "na": "\u0412\u0430\u0442\u0438\u043a\u0430\u043d"
}, {
  "co": "gb",
  "ph": "44",
  "na": "\u0412\u0435\u043b\u0438\u043a\u043e\u0431\u0440\u0438\u0442\u0430\u043d\u0438\u044f"
}, {
  "co": "hu",
  "ph": "36",
  "na": "\u0412\u0435\u043d\u0433\u0440\u0438\u044f"
}, {
  "co": "ve",
  "ph": "58",
  "na": "\u0412\u0435\u043d\u0435\u0441\u0443\u044d\u043b\u0430"
}, {
  "co": "vi",
  "ph": "1340",
  "na": "\u0412\u0438\u0440\u0433\u0438\u043d\u0441\u043a\u0438\u0435 \u043e-\u0432\u0430 (\u0421\u0428\u0410)"
}, {
  "co": "um",
  "ph": "1",
  "na": "\u0412\u043d\u0435\u0448\u043d\u0438\u0435 \u043c\u0430\u043b\u044b\u0435 \u043e\u0441\u0442\u0440\u043e\u0432\u0430 (\u0421\u0428\u0410)"
}, {
  "co": "tl",
  "ph": "670",
  "na": "\u0412\u043e\u0441\u0442\u043e\u0447\u043d\u044b\u0439 \u0422\u0438\u043c\u043e\u0440"
}, {
  "co": "vn",
  "ph": "84",
  "na": "\u0412\u044c\u0435\u0442\u043d\u0430\u043c"
}, {
  "co": "ga",
  "ph": "241",
  "na": "\u0413\u0430\u0431\u043e\u043d"
}, {
  "co": "ht",
  "ph": "509",
  "na": "\u0413\u0430\u0438\u0442\u0438"
}, {
  "co": "gy",
  "ph": "592",
  "na": "\u0413\u0430\u0439\u0430\u043d\u0430"
}, {
  "co": "gm",
  "ph": "220",
  "na": "\u0413\u0430\u043c\u0431\u0438\u044f"
}, {
  "co": "gh",
  "ph": "233",
  "na": "\u0413\u0430\u043d\u0430"
}, {
  "co": "gp",
  "ph": "590",
  "na": "\u0413\u0432\u0430\u0434\u0435\u043b\u0443\u043f\u0430"
}, {
  "co": "gt",
  "ph": "502",
  "na": "\u0413\u0432\u0430\u0442\u0435\u043c\u0430\u043b\u0430"
}, {
  "co": "gn",
  "ph": "224",
  "na": "\u0413\u0432\u0438\u043d\u0435\u044f"
}, {
  "co": "gw",
  "ph": "245",
  "na": "\u0413\u0432\u0438\u043d\u0435\u044f-\u0411\u0438\u0441\u0430\u0443"
}, {
  "co": "de",
  "ph": "49",
  "na": "\u0413\u0435\u0440\u043c\u0430\u043d\u0438\u044f"
}, {
  "co": "gi",
  "ph": "350",
  "na": "\u0413\u0438\u0431\u0440\u0430\u043b\u0442\u0430\u0440"
}, {
  "co": "hn",
  "ph": "504",
  "na": "\u0413\u043e\u043d\u0434\u0443\u0440\u0430\u0441"
}, {
  "co": "hk",
  "ph": "852",
  "na": "\u0413\u043e\u043d\u043a\u043e\u043d\u0433"
}, {
  "co": "gd",
  "ph": "1473",
  "na": "\u0413\u0440\u0435\u043d\u0430\u0434\u0430"
}, {
  "co": "gl",
  "ph": "299",
  "na": "\u0413\u0440\u0435\u043d\u043b\u0430\u043d\u0434\u0438\u044f"
}, {
  "co": "gr",
  "ph": "30",
  "na": "\u0413\u0440\u0435\u0446\u0438\u044f"
}, {
  "co": "ge",
  "ph": "995",
  "na": "\u0413\u0440\u0443\u0437\u0438\u044f"
}, {
  "co": "gu",
  "ph": "1671",
  "na": "\u0413\u0443\u0430\u043c"
}, {
  "co": "dk",
  "ph": "45",
  "na": "\u0414\u0430\u043d\u0438\u044f"
}, {
  "co": "cd",
  "ph": "243",
  "na": "\u0414\u0435\u043c\u043e\u043a\u0440\u0430\u0442\u0438\u0447\u0435\u0441\u043a\u0430\u044f \u0420\u0435\u0441\u043f\u0443\u0431\u043b\u0438\u043a\u0430 \u041a\u043e\u043d\u0433\u043e"
}, {
  "co": "dj",
  "ph": "253",
  "na": "\u0414\u0436\u0438\u0431\u0443\u0442\u0438"
}, {
  "co": "dm",
  "ph": "1767",
  "na": "\u0414\u043e\u043c\u0438\u043d\u0438\u043a\u0430"
}, {
  "co": "do",
  "ph": "1809",
  "na": "\u0414\u043e\u043c\u0438\u043d\u0438\u043a\u0430\u043d\u0441\u043a\u0430\u044f \u0420\u0435\u0441\u043f\u0443\u0431\u043b\u0438\u043a\u0430"
}, {
  "co": "eg",
  "ph": "20",
  "na": "\u0415\u0433\u0438\u043f\u0435\u0442"
}, {
  "co": "zm",
  "ph": "260",
  "na": "\u0417\u0430\u043c\u0431\u0438\u044f"
}, {
  "co": "zw",
  "ph": "263",
  "na": "\u0417\u0438\u043c\u0431\u0430\u0431\u0432\u0435"
}, {
  "co": "il",
  "ph": "972",
  "na": "\u0418\u0437\u0440\u0430\u0438\u043b\u044c"
}, {
  "co": "in",
  "ph": "91",
  "na": "\u0418\u043d\u0434\u0438\u044f"
}, {
  "co": "id",
  "ph": "62",
  "na": "\u0418\u043d\u0434\u043e\u043d\u0435\u0437\u0438\u044f"
}, {
  "co": "jo",
  "ph": "962",
  "na": "\u0418\u043e\u0440\u0434\u0430\u043d\u0438\u044f"
}, {
  "co": "iq",
  "ph": "964",
  "na": "\u0418\u0440\u0430\u043a"
}, {
  "co": "ir",
  "ph": "98",
  "na": "\u0418\u0440\u0430\u043d"
}, {
  "co": "ie",
  "ph": "353",
  "na": "\u0418\u0440\u043b\u0430\u043d\u0434\u0438\u044f"
}, {
  "co": "is",
  "ph": "354",
  "na": "\u0418\u0441\u043b\u0430\u043d\u0434\u0438\u044f"
}, {
  "co": "es",
  "ph": "34",
  "na": "\u0418\u0441\u043f\u0430\u043d\u0438\u044f"
}, {
  "co": "it",
  "ph": "39",
  "na": "\u0418\u0442\u0430\u043b\u0438\u044f"
}, {
  "co": "ye",
  "ph": "967",
  "na": "\u0419\u0435\u043c\u0435\u043d"
}, {
  "co": "kz",
  "ph": "7",
  "na": "\u041a\u0430\u0437\u0430\u0445\u0441\u0442\u0430\u043d"
}, {
  "co": "ky",
  "ph": "1345",
  "na": "\u041a\u0430\u0439\u043c\u0430\u043d\u043e\u0432\u044b \u041e\u0441\u0442\u0440\u043e\u0432\u0430"
}, {
  "co": "kh",
  "ph": "855",
  "na": "\u041a\u0430\u043c\u0431\u043e\u0434\u0436\u0430"
}, {
  "co": "cm",
  "ph": "237",
  "na": "\u041a\u0430\u043c\u0435\u0440\u0443\u043d"
}, {
  "co": "ca",
  "ph": "1",
  "na": "\u041a\u0430\u043d\u0430\u0434\u0430"
}, {
  "co": "qa",
  "ph": "974",
  "na": "\u041a\u0430\u0442\u0430\u0440"
}, {
  "co": "ke",
  "ph": "254",
  "na": "\u041a\u0435\u043d\u0438\u044f"
}, {
  "co": "cy",
  "ph": "357",
  "na": "\u041a\u0438\u043f\u0440"
}, {
  "co": "kg",
  "ph": "996",
  "na": "\u041a\u0438\u0440\u0433\u0438\u0437\u0438\u044f"
}, {
  "co": "ki",
  "ph": "686",
  "na": "\u041a\u0438\u0440\u0438\u0431\u0430\u0442\u0438"
}, {
  "co": "cn",
  "ph": "86",
  "na": "\u041a\u0438\u0442\u0430\u0439"
}, {
  "co": "cc",
  "ph": "61",
  "na": "\u041a\u043e\u043a\u043e\u0441\u043e\u0432\u044b\u0435 \u043e-\u0432\u0430"
}, {
  "co": "co",
  "ph": "57",
  "na": "\u041a\u043e\u043b\u0443\u043c\u0431\u0438\u044f"
}, {
  "co": "km",
  "ph": "269",
  "na": "\u041a\u043e\u043c\u043e\u0440\u0441\u043a\u0438\u0435 \u043e-\u0432\u0430"
}, {
  "co": "cg",
  "ph": "242",
  "na": "\u041a\u043e\u043d\u0433\u043e"
}, {
  "co": "kp",
  "ph": "850",
  "na": "\u041a\u043e\u0440\u0435\u0439\u0441\u043a\u0430\u044f \u041d\u0430\u0440\u043e\u0434\u043d\u043e-\u0414\u0435\u043c\u043e\u043a\u0440\u0430\u0442\u0438\u0447\u0435\u0441\u043a\u0430\u044f \u0420\u0435\u0441\u043f\u0443\u0431\u043b\u0438\u043a\u0430"
}, {
  "co": "cr",
  "ph": "506",
  "na": "\u041a\u043e\u0441\u0442\u0430-\u0420\u0438\u043a\u0430"
}, {
  "co": "ci",
  "ph": "225",
  "na": "\u041a\u043e\u0442 \u0434\u2019\u0418\u0432\u0443\u0430\u0440"
}, {
  "co": "cu",
  "ph": "53",
  "na": "\u041a\u0443\u0431\u0430"
}, {
  "co": "kw",
  "ph": "965",
  "na": "\u041a\u0443\u0432\u0435\u0439\u0442"
}, {
  "co": "cw",
  "ph": "599",
  "na": "\u041a\u044e\u0440\u0430\u0441\u0430\u043e"
}, {
  "co": "la",
  "ph": "856",
  "na": "\u041b\u0430\u043e\u0441"
}, {
  "co": "lv",
  "ph": "371",
  "na": "\u041b\u0430\u0442\u0432\u0438\u044f"
}, {
  "co": "ls",
  "ph": "266",
  "na": "\u041b\u0435\u0441\u043e\u0442\u043e"
}, {
  "co": "lr",
  "ph": "231",
  "na": "\u041b\u0438\u0431\u0435\u0440\u0438\u044f"
}, {
  "co": "lb",
  "ph": "961",
  "na": "\u041b\u0438\u0432\u0430\u043d"
}, {
  "co": "ly",
  "ph": "218",
  "na": "\u041b\u0438\u0432\u0438\u044f"
}, {
  "co": "lt",
  "ph": "370",
  "na": "\u041b\u0438\u0442\u0432\u0430"
}, {
  "co": "li",
  "ph": "423",
  "na": "\u041b\u0438\u0445\u0442\u0435\u043d\u0448\u0442\u0435\u0439\u043d"
}, {
  "co": "lu",
  "ph": "352",
  "na": "\u041b\u044e\u043a\u0441\u0435\u043c\u0431\u0443\u0440\u0433"
}, {
  "co": "mu",
  "ph": "230",
  "na": "\u041c\u0430\u0432\u0440\u0438\u043a\u0438\u0439"
}, {
  "co": "mr",
  "ph": "222",
  "na": "\u041c\u0430\u0432\u0440\u0438\u0442\u0430\u043d\u0438\u044f"
}, {
  "co": "mg",
  "ph": "261",
  "na": "\u041c\u0430\u0434\u0430\u0433\u0430\u0441\u043a\u0430\u0440"
}, {
  "co": "yt",
  "ph": "262",
  "na": "\u041c\u0430\u0439\u043e\u0442\u0442\u0430"
}, {
  "co": "mk",
  "ph": "389",
  "na": "\u041c\u0430\u043a\u0435\u0434\u043e\u043d\u0438\u044f"
}, {
  "co": "mw",
  "ph": "265",
  "na": "\u041c\u0430\u043b\u0430\u0432\u0438"
}, {
  "co": "my",
  "ph": "60",
  "na": "\u041c\u0430\u043b\u0430\u0439\u0437\u0438\u044f"
}, {
  "co": "ml",
  "ph": "223",
  "na": "\u041c\u0430\u043b\u0438"
}, {
  "co": "mv",
  "ph": "960",
  "na": "\u041c\u0430\u043b\u044c\u0434\u0438\u0432\u0441\u043a\u0438\u0435 \u043e-\u0432\u0430"
}, {
  "co": "mt",
  "ph": "356",
  "na": "\u041c\u0430\u043b\u044c\u0442\u0430"
}, {
  "co": "ma",
  "ph": "212",
  "na": "\u041c\u0430\u0440\u043e\u043a\u043a\u043e"
}, {
  "co": "mq",
  "ph": "596",
  "na": "\u041c\u0430\u0440\u0442\u0438\u043d\u0438\u043a\u0430"
}, {
  "co": "mh",
  "ph": "692",
  "na": "\u041c\u0430\u0440\u0448\u0430\u043b\u043b\u043e\u0432\u044b \u043e-\u0432\u0430"
}, {
  "co": "mx",
  "ph": "52",
  "na": "\u041c\u0435\u043a\u0441\u0438\u043a\u0430"
}, {
  "co": "fm",
  "ph": "691",
  "na": "\u041c\u0438\u043a\u0440\u043e\u043d\u0435\u0437\u0438\u044f"
}, {
  "co": "mz",
  "ph": "258",
  "na": "\u041c\u043e\u0437\u0430\u043c\u0431\u0438\u043a"
}, {
  "co": "md",
  "ph": "373",
  "na": "\u041c\u043e\u043b\u0434\u0430\u0432\u0438\u044f"
}, {
  "co": "mc",
  "ph": "377",
  "na": "\u041c\u043e\u043d\u0430\u043a\u043e"
}, {
  "co": "mn",
  "ph": "976",
  "na": "\u041c\u043e\u043d\u0433\u043e\u043b\u0438\u044f"
}, {
  "co": "ms",
  "ph": "1664",
  "na": "\u041c\u043e\u043d\u0441\u0435\u0440\u0440\u0430\u0442"
}, {
  "co": "mm",
  "ph": "95",
  "na": "\u041c\u044c\u044f\u043d\u043c\u0430"
}, {
  "co": "na",
  "ph": "264",
  "na": "\u041d\u0430\u043c\u0438\u0431\u0438\u044f"
}, {
  "co": "nr",
  "ph": "674",
  "na": "\u041d\u0430\u0443\u0440\u0443"
}, {
  "co": "np",
  "ph": "977",
  "na": "\u041d\u0435\u043f\u0430\u043b"
}, {
  "co": "ne",
  "ph": "227",
  "na": "\u041d\u0438\u0433\u0435\u0440"
}, {
  "co": "ng",
  "ph": "234",
  "na": "\u041d\u0438\u0433\u0435\u0440\u0438\u044f"
}, {
  "co": "nl",
  "ph": "31",
  "na": "\u041d\u0438\u0434\u0435\u0440\u043b\u0430\u043d\u0434\u044b"
}, {
  "co": "ni",
  "ph": "505",
  "na": "\u041d\u0438\u043a\u0430\u0440\u0430\u0433\u0443\u0430"
}, {
  "co": "nu",
  "ph": "683",
  "na": "\u041d\u0438\u0443\u0435"
}, {
  "co": "nz",
  "ph": "64",
  "na": "\u041d\u043e\u0432\u0430\u044f \u0417\u0435\u043b\u0430\u043d\u0434\u0438\u044f"
}, {
  "co": "nc",
  "ph": "687",
  "na": "\u041d\u043e\u0432\u0430\u044f \u041a\u0430\u043b\u0435\u0434\u043e\u043d\u0438\u044f"
}, {
  "co": "no",
  "ph": "47",
  "na": "\u041d\u043e\u0440\u0432\u0435\u0433\u0438\u044f"
}, {
  "co": "ae",
  "ph": "971",
  "na": "\u041e\u0410\u042d"
}, {
  "co": "om",
  "ph": "968",
  "na": "\u041e\u043c\u0430\u043d"
}, {
  "co": "nf",
  "ph": "672",
  "na": "\u041e\u0441\u0442\u0440\u043e\u0432 \u041d\u043e\u0440\u0444\u043e\u043b\u043a"
}, {
  "co": "cx",
  "ph": "61",
  "na": "\u041e\u0441\u0442\u0440\u043e\u0432 \u0420\u043e\u0436\u0434\u0435\u0441\u0442\u0432\u0430"
}, {
  "co": "bl",
  "ph": "590",
  "na": "\u041e\u0441\u0442\u0440\u043e\u0432 \u0421\u0432\u044f\u0442\u043e\u0433\u043e \u0411\u0430\u0440\u0442\u043e\u043b\u043e\u043c\u0435\u044f"
}, {
  "co": "mf",
  "ph": "590",
  "na": "\u041e\u0441\u0442\u0440\u043e\u0432 \u0421\u0432\u044f\u0442\u043e\u0433\u043e \u041c\u0430\u0440\u0442\u0438\u043d\u0430"
}, {
  "co": "sh",
  "ph": "290",
  "na": "\u041e\u0441\u0442\u0440\u043e\u0432 \u0421\u0432\u044f\u0442\u043e\u0439 \u0415\u043b\u0435\u043d\u044b"
}, {
  "co": "cv",
  "ph": "238",
  "na": "\u041e\u0441\u0442\u0440\u043e\u0432\u0430 \u0417\u0435\u043b\u0435\u043d\u043e\u0433\u043e \u041c\u044b\u0441\u0430"
}, {
  "co": "ck",
  "ph": "682",
  "na": "\u041e\u0441\u0442\u0440\u043e\u0432\u0430 \u041a\u0443\u043a\u0430"
}, {
  "co": "tc",
  "ph": "1649",
  "na": "\u041e\u0441\u0442\u0440\u043e\u0432\u0430 \u0422\u0451\u0440\u043a\u0441 \u0438 \u041a\u0430\u0439\u043a\u043e\u0441"
}, {
  "co": "wf",
  "ph": "681",
  "na": "\u041e\u0441\u0442\u0440\u043e\u0432\u0430 \u0423\u043e\u043b\u043b\u0438\u0441 \u0438 \u0424\u0443\u0442\u0443\u043d\u0430"
}, {
  "co": "pk",
  "ph": "92",
  "na": "\u041f\u0430\u043a\u0438\u0441\u0442\u0430\u043d"
}, {
  "co": "pw",
  "ph": "680",
  "na": "\u041f\u0430\u043b\u0430\u0443"
}, {
  "co": "ps",
  "ph": "970",
  "na": "\u041f\u0430\u043b\u0435\u0441\u0442\u0438\u043d\u0441\u043a\u0438\u0435 \u0442\u0435\u0440\u0440\u0438\u0442\u043e\u0440\u0438\u0438"
}, {
  "co": "pa",
  "ph": "507",
  "na": "\u041f\u0430\u043d\u0430\u043c\u0430"
}, {
  "co": "pg",
  "ph": "675",
  "na": "\u041f\u0430\u043f\u0443\u0430 \u2013 \u041d\u043e\u0432\u0430\u044f \u0413\u0432\u0438\u043d\u0435\u044f"
}, {
  "co": "py",
  "ph": "595",
  "na": "\u041f\u0430\u0440\u0430\u0433\u0432\u0430\u0439"
}, {
  "co": "pe",
  "ph": "51",
  "na": "\u041f\u0435\u0440\u0443"
}, {
  "co": "pn",
  "ph": "870",
  "na": "\u041f\u0438\u0442\u043a\u044d\u0440\u043d"
}, {
  "co": "pl",
  "ph": "48",
  "na": "\u041f\u043e\u043b\u044c\u0448\u0430"
}, {
  "co": "pt",
  "ph": "351",
  "na": "\u041f\u043e\u0440\u0442\u0443\u0433\u0430\u043b\u0438\u044f"
}, {
  "co": "pr",
  "ph": "1787",
  "na": "\u041f\u0443\u044d\u0440\u0442\u043e-\u0420\u0438\u043a\u043e"
}, {
  "co": "kr",
  "ph": "82",
  "na": "\u0420\u0435\u0441\u043f\u0443\u0431\u043b\u0438\u043a\u0430 \u041a\u043e\u0440\u0435\u044f"
}, {
  "co": "re",
  "ph": "262",
  "na": "\u0420\u0435\u044e\u043d\u044c\u043e\u043d"
}, {
  "co": "ru",
  "ph": "7",
  "na": "\u0420\u043e\u0441\u0441\u0438\u0439\u0441\u043a\u0430\u044f \u0424\u0435\u0434\u0435\u0440\u0430\u0446\u0438\u044f"
}, {
  "co": "rw",
  "ph": "250",
  "na": "\u0420\u0443\u0430\u043d\u0434\u0430"
}, {
  "co": "ro",
  "ph": "40",
  "na": "\u0420\u0443\u043c\u044b\u043d\u0438\u044f"
}, {
  "co": "sv",
  "ph": "503",
  "na": "\u0421\u0430\u043b\u044c\u0432\u0430\u0434\u043e\u0440"
}, {
  "co": "ws",
  "ph": "685",
  "na": "\u0421\u0430\u043c\u043e\u0430"
}, {
  "co": "sm",
  "ph": "378",
  "na": "\u0421\u0430\u043d-\u041c\u0430\u0440\u0438\u043d\u043e"
}, {
  "co": "st",
  "ph": "239",
  "na": "\u0421\u0430\u043d-\u0422\u043e\u043c\u0435 \u0438 \u041f\u0440\u0438\u043d\u0441\u0438\u043f\u0435"
}, {
  "co": "sa",
  "ph": "966",
  "na": "\u0421\u0430\u0443\u0434\u043e\u0432\u0441\u043a\u0430\u044f \u0410\u0440\u0430\u0432\u0438\u044f"
}, {
  "co": "sz",
  "ph": "268",
  "na": "\u0421\u0432\u0430\u0437\u0438\u043b\u0435\u043d\u0434"
}, {
  "co": "mp",
  "ph": "1670",
  "na": "\u0421\u0435\u0432\u0435\u0440\u043d\u044b\u0435 \u041c\u0430\u0440\u0438\u0430\u043d\u0441\u043a\u0438\u0435 \u043e-\u0432\u0430"
}, {
  "co": "sc",
  "ph": "248",
  "na": "\u0421\u0435\u0439\u0448\u0435\u043b\u044b"
}, {
  "co": "pm",
  "ph": "508",
  "na": "\u0421\u0435\u043d-\u041f\u044c\u0435\u0440 \u0438 \u041c\u0438\u043a\u0435\u043b\u043e\u043d"
}, {
  "co": "sn",
  "ph": "221",
  "na": "\u0421\u0435\u043d\u0435\u0433\u0430\u043b"
}, {
  "co": "vc",
  "ph": "1784",
  "na": "\u0421\u0435\u043d\u0442-\u0412\u0438\u043d\u0441\u0435\u043d\u0442 \u0438 \u0413\u0440\u0435\u043d\u0430\u0434\u0438\u043d\u044b"
}, {
  "co": "kn",
  "ph": "1869",
  "na": "\u0421\u0435\u043d\u0442-\u041a\u0438\u0442\u0441 \u0438 \u041d\u0435\u0432\u0438\u0441"
}, {
  "co": "lc",
  "ph": "1758",
  "na": "\u0421\u0435\u043d\u0442-\u041b\u044e\u0441\u0438\u044f"
}, {
  "co": "rs",
  "ph": "381",
  "na": "\u0421\u0435\u0440\u0431\u0438\u044f"
}, {
  "co": "sg",
  "ph": "65",
  "na": "\u0421\u0438\u043d\u0433\u0430\u043f\u0443\u0440"
}, {
  "co": "sx",
  "ph": "599",
  "na": "\u0421\u0438\u043d\u0442-\u041c\u0430\u0440\u0442\u0435\u043d"
}, {
  "co": "sy",
  "ph": "963",
  "na": "\u0421\u0438\u0440\u0438\u0439\u0441\u043a\u0430\u044f \u0410\u0440\u0430\u0431\u0441\u043a\u0430\u044f \u0420\u0435\u0441\u043f\u0443\u0431\u043b\u0438\u043a\u0430"
}, {
  "co": "sk",
  "ph": "421",
  "na": "\u0421\u043b\u043e\u0432\u0430\u043a\u0438\u044f"
}, {
  "co": "si",
  "ph": "386",
  "na": "\u0421\u043b\u043e\u0432\u0435\u043d\u0438\u044f"
}, {
  "co": "us",
  "ph": "1",
  "na": "\u0421\u043e\u0435\u0434\u0438\u043d\u0435\u043d\u043d\u044b\u0435 \u0428\u0442\u0430\u0442\u044b"
}, {
  "co": "sb",
  "ph": "677",
  "na": "\u0421\u043e\u043b\u043e\u043c\u043e\u043d\u043e\u0432\u044b \u041e\u0441\u0442\u0440\u043e\u0432\u0430"
}, {
  "co": "so",
  "ph": "252",
  "na": "\u0421\u043e\u043c\u0430\u043b\u0438"
}, {
  "co": "sd",
  "ph": "249",
  "na": "\u0421\u0443\u0434\u0430\u043d"
}, {
  "co": "sr",
  "ph": "597",
  "na": "\u0421\u0443\u0440\u0438\u043d\u0430\u043c"
}, {
  "co": "sl",
  "ph": "232",
  "na": "\u0421\u044c\u0435\u0440\u0440\u0430-\u041b\u0435\u043e\u043d\u0435"
}, {
  "co": "tj",
  "ph": "992",
  "na": "\u0422\u0430\u0434\u0436\u0438\u043a\u0438\u0441\u0442\u0430\u043d"
}, {
  "co": "th",
  "ph": "66",
  "na": "\u0422\u0430\u0438\u043b\u0430\u043d\u0434"
}, {
  "co": "tw",
  "ph": "886",
  "na": "\u0422\u0430\u0439\u0432\u0430\u043d\u044c"
}, {
  "co": "tz",
  "ph": "255",
  "na": "\u0422\u0430\u043d\u0437\u0430\u043d\u0438\u044f"
}, {
  "co": "tg",
  "ph": "228",
  "na": "\u0422\u043e\u0433\u043e"
}, {
  "co": "tk",
  "ph": "690",
  "na": "\u0422\u043e\u043a\u0435\u043b\u0430\u0443"
}, {
  "co": "to",
  "ph": "676",
  "na": "\u0422\u043e\u043d\u0433\u0430"
}, {
  "co": "tt",
  "ph": "1868",
  "na": "\u0422\u0440\u0438\u043d\u0438\u0434\u0430\u0434 \u0438 \u0422\u043e\u0431\u0430\u0433\u043e"
}, {
  "co": "tv",
  "ph": "688",
  "na": "\u0422\u0443\u0432\u0430\u043b\u0443"
}, {
  "co": "tn",
  "ph": "216",
  "na": "\u0422\u0443\u043d\u0438\u0441"
}, {
  "co": "tm",
  "ph": "993",
  "na": "\u0422\u0443\u0440\u043a\u043c\u0435\u043d\u0438\u0441\u0442\u0430\u043d"
}, {
  "co": "tr",
  "ph": "90",
  "na": "\u0422\u0443\u0440\u0446\u0438\u044f"
}, {
  "co": "ug",
  "ph": "256",
  "na": "\u0423\u0433\u0430\u043d\u0434\u0430"
}, {
  "co": "uz",
  "ph": "998",
  "na": "\u0423\u0437\u0431\u0435\u043a\u0438\u0441\u0442\u0430\u043d"
}, {
  "co": "ua",
  "ph": "380",
  "na": "\u0423\u043a\u0440\u0430\u0438\u043d\u0430"
}, {
  "co": "uy",
  "ph": "598",
  "na": "\u0423\u0440\u0443\u0433\u0432\u0430\u0439"
}, {
  "co": "fo",
  "ph": "298",
  "na": "\u0424\u0430\u0440\u0435\u0440\u0441\u043a\u0438\u0435 \u043e-\u0432\u0430"
}, {
  "co": "fj",
  "ph": "679",
  "na": "\u0424\u0438\u0434\u0436\u0438"
}, {
  "co": "ph",
  "ph": "63",
  "na": "\u0424\u0438\u043b\u0438\u043f\u043f\u0438\u043d\u044b"
}, {
  "co": "fi",
  "ph": "358",
  "na": "\u0424\u0438\u043d\u043b\u044f\u043d\u0434\u0438\u044f"
}, {
  "co": "fk",
  "ph": "500",
  "na": "\u0424\u043e\u043b\u043a\u043b\u0435\u043d\u0434\u0441\u043a\u0438\u0435 \u043e-\u0432\u0430"
}, {
  "co": "fr",
  "ph": "33",
  "na": "\u0424\u0440\u0430\u043d\u0446\u0438\u044f"
}, {
  "co": "gf",
  "ph": "594",
  "na": "\u0424\u0440\u0430\u043d\u0446\u0443\u0437\u0441\u043a\u0430\u044f \u0413\u0432\u0438\u0430\u043d\u0430"
}, {
  "co": "pf",
  "ph": "689",
  "na": "\u0424\u0440\u0430\u043d\u0446\u0443\u0437\u0441\u043a\u0430\u044f \u041f\u043e\u043b\u0438\u043d\u0435\u0437\u0438\u044f"
}, {
  "co": "hr",
  "ph": "385",
  "na": "\u0425\u043e\u0440\u0432\u0430\u0442\u0438\u044f"
}, {
  "co": "cf",
  "ph": "236",
  "na": "\u0426\u0410\u0420"
}, {
  "co": "td",
  "ph": "235",
  "na": "\u0427\u0430\u0434"
}, {
  "co": "me",
  "ph": "382",
  "na": "\u0427\u0435\u0440\u043d\u043e\u0433\u043e\u0440\u0438\u044f"
}, {
  "co": "cz",
  "ph": "420",
  "na": "\u0427\u0435\u0445\u0438\u044f"
}, {
  "co": "cl",
  "ph": "56",
  "na": "\u0427\u0438\u043b\u0438"
}, {
  "co": "ch",
  "ph": "41",
  "na": "\u0428\u0432\u0435\u0439\u0446\u0430\u0440\u0438\u044f"
}, {
  "co": "se",
  "ph": "46",
  "na": "\u0428\u0432\u0435\u0446\u0438\u044f"
}, {
  "co": "lk",
  "ph": "94",
  "na": "\u0428\u0440\u0438-\u041b\u0430\u043d\u043a\u0430"
}, {
  "co": "ec",
  "ph": "593",
  "na": "\u042d\u043a\u0432\u0430\u0434\u043e\u0440"
}, {
  "co": "gq",
  "ph": "240",
  "na": "\u042d\u043a\u0432\u0430\u0442\u043e\u0440\u0438\u0430\u043b\u044c\u043d\u0430\u044f \u0413\u0432\u0438\u043d\u0435\u044f"
}, {
  "co": "er",
  "ph": "291",
  "na": "\u042d\u0440\u0438\u0442\u0440\u0435\u044f"
}, {
  "co": "ee",
  "ph": "372",
  "na": "\u042d\u0441\u0442\u043e\u043d\u0438\u044f"
}, {
  "co": "et",
  "ph": "251",
  "na": "\u042d\u0444\u0438\u043e\u043f\u0438\u044f"
}, {
  "co": "za",
  "ph": "27",
  "na": "\u042e\u0410\u0420"
}, {
  "co": "ss",
  "ph": "211",
  "na": "\u042e\u0436\u043d\u044b\u0439 \u0421\u0443\u0434\u0430\u043d"
}, {
  "co": "jm",
  "ph": "1876",
  "na": "\u042f\u043c\u0430\u0439\u043a\u0430"
}, {
  "co": "jp",
  "ph": "81",
  "na": "\u042f\u043f\u043e\u043d\u0438\u044f"
}];
